(function() {
  const makeTablesResponsive = () => {
    const richTextBlocks = document.querySelectorAll('.rich-text__text');

    richTextBlocks.forEach(block => {
      const tables = block.querySelectorAll('table');

      tables.forEach(table => {
        // Skip if already processed
        if (table.parentElement.classList.contains('table-wrapper')) return;

        // Wrap table in responsive container
        const wrapper = document.createElement('div');
        wrapper.className = 'table-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    });

    console.log('tables fixed')
  };

  // Run on page load
  makeTablesResponsive();

  // Run when Shopify section is reloaded
  document.addEventListener('shopify:section:load', makeTablesResponsive);
})();

